const commonConfig = {
  confirm_btn: 'Confirm',
  cancel_btn: 'Cancel',
  not_data: 'No Data',
  updata_data_suc: 'Data update failed',
  updata_data_fail: '数据更新失败',
  online: 'on-line',
  off_line: 'off-line',
  waiting: 'waiting...'
};

export default commonConfig;
